import React, { useState } from "react";
import { Input } from "../Elements";
import { isInputValidationError } from "../../../common/helpers/paymentHelpers";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";


type Props = {
    isVisible: boolean
}
export type PaymentDescriptionRef = {
    getDescription:()=>string
}
const PaymentDescriptionArea = React.forwardRef<PaymentDescriptionRef, Props>((props: Props, ref) => {
    const { validationErrors } = useSelector((state: RootStateType) => state.paymentPage);

    const { isVisible } = props;

    React.useImperativeHandle(ref, () => ({

        getDescription() {
            return paymentDesc;
        },
    }));


    const [paymentDesc, setPaymentDesc] = useState("");

    if (!isVisible) {
        return null;
    }
    return (
        <Input
            label=""
            className={`w-full bg-white mt-4 resize-none rounded-lg border border-gray-200 justify-start  
            ${isInputValidationError("paymentDesc", validationErrors) && !paymentDesc && "!border-error"}`}
            name="orderDesc"
            required
            placeholder="Ödeme Açıklaması"
            type="text"
            onChange={(event: any) => setPaymentDesc(event.target.value)}
        // value={amount}
        />
    );
})
export default PaymentDescriptionArea;